export const ImgUtilService = {
    preloadImg(imgSrc, loadedCb) {
        let img = new Image();
        img.onload = () => {
            loadedCb();
        };
        img.src = imgSrc;
    },
};
